import { createFileRoute } from "@tanstack/react-router";
import RgpdObligationsPage from "@/pages/docs/RgpdObligationsPage";

export const Route = createFileRoute("/docs/rgpd-obligations")({
  component: RgpdObligationsPage,
});
